import React, { useCallback, createElement as _createElement } from 'react';
import PropTypes from 'prop-types';
import { useFeatures } from '@atc/features';
import BatteryHealthBadge from './badges/BatteryHealthBadge';
import CertifiedBadge from './badges/CertifiedBadge';
import FuelTypeBadge from './badges/FuelTypeBadge';
import ProductBadge from './badges/ProductBadge';
import VHRBadge from './badges/VHRBadge';

/**
 *  Displays applicable info badges on listing cards:
 *  - Battery Health
 *  - Highlight alternative fuel type
 *  - Certified program
 *  - Vehicle History Report quick link
 *
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function InventoryListingBadges(_ref) {
  let {
    enableCertifiedBadges = true,
    enableCpoVhrBadges,
    enableVhrBadges = false,
    enableFuelTypeBadges = true,
    listing,
    onCertifiedTileClick,
    onProductTileClick,
    onVhrBadgeClick
  } = _ref;
  const {
    battery_health: [enableBatteryHealth]
  } = useFeatures(['battery_health']);
  const {
    certifiedTiles = [],
    electricComponentInfo: {
      batteryDegradationInfo
    } = {},
    fuelType,
    listingType = '',
    listingTypes = [],
    productTiles = [],
    specifications,
    vhrPreview = [],
    vdpBaseUrl = ''
  } = listing || {};
  const handleCertifiedTileClick = useCallback(event => onCertifiedTileClick(event, listing), [listing, onCertifiedTileClick]);
  const handleProductTileClick = useCallback(event => onProductTileClick(event, listing), [listing, onProductTileClick]);
  const handleVhrBadgeClick = useCallback(event => onVhrBadgeClick(event, listing), [listing, onVhrBadgeClick]);
  const displayBadges = enableCertifiedBadges && certifiedTiles.length > 0 || enableFuelTypeBadges && (fuelType?.group || fuelType) || enableBatteryHealth && batteryDegradationInfo?.healthDescription || enableCpoVhrBadges && productTiles.length > 0 || enableVhrBadges && vhrPreview.length > 0;
  return displayBadges && /*#__PURE__*/_jsxs("div", {
    className: "display-flex flex-wrap gap-2 margin-top-4",
    children: [enableCertifiedBadges && certifiedTiles.map(_ref2 => {
      let {
        label
      } = _ref2;
      return /*#__PURE__*/_jsx(CertifiedBadge, {
        label: label,
        listingType: listingType,
        listingTypes: listingTypes,
        onClick: handleCertifiedTileClick
      }, label);
    }), enableFuelTypeBadges && /*#__PURE__*/_jsx(FuelTypeBadge, {
      engineName: specifications?.engine?.value,
      fuelGroup: fuelType?.group,
      fuelName: fuelType
    }, "fuel-type"), enableBatteryHealth && /*#__PURE__*/_jsx(BatteryHealthBadge, {
      ...batteryDegradationInfo
    }, "battery-health"), enableCpoVhrBadges && productTiles.map(badge => /*#__PURE__*/_createElement(ProductBadge, {
      ...badge,
      key: badge.label,
      onClick: handleProductTileClick
    })), enableVhrBadges && vhrPreview.map(code => /*#__PURE__*/_jsx(VHRBadge, {
      vdpBaseUrl: vdpBaseUrl,
      vhrCode: code,
      listingType: listingType,
      onClick: handleVhrBadgeClick
    }, code))]
  }, "listing-badges");
}
export default InventoryListingBadges;